import type { DesignModule } from '../types'
import { PorcelainAdminApiTokens } from './components/admin-api-tokens-screen'
import { PorcelainAdminCredentials } from './components/admin-credentials-screen'
import { PorcelainAdminLocations } from './components/admin-locations-screen'
import { PorcelainAdminPermissions } from './components/admin-permissions-screen'
import { PorcelainAdminRoles } from './components/admin-roles-screen'
import { PorcelainAdminTenantDetail, PorcelainAdminTenants } from './components/admin-tenants-screen'
import { PorcelainAdminUsers } from './components/admin-users-screen'
import { PorcelainClients } from './components/clients-screen'
import { PorcelainDashboard } from './components/dashboard-screen'
import { PorcelainLocationDetail } from './components/location-detail-screen'
import { PorcelainLocations } from './components/locations-screen'
import { PorcelainManagedDevices } from './components/managed-devices-screen'
import { PorcelainNetwork } from './components/network-screen'
import { PorcelainPosTerminals } from './components/pos-terminals-screen'
import { PorcelainReservations } from './components/reservations-screen'
import { PorcelainShell } from './components/shell'
import { PorcelainSwitchPorts } from './components/switch-ports-screen'
import { PorcelainWanSettings } from './components/wan-settings-screen'

export const v1: DesignModule = {
  name: 'Porcelain',
  description: 'Calm, Apple-clean: soft surfaces, generous whitespace, one blue accent, Inter.',
  Shell: PorcelainShell,
  screens: {
    dashboard: PorcelainDashboard,
    locations: PorcelainLocations,
    locationDetail: PorcelainLocationDetail,
    network: PorcelainNetwork,
    wanSettings: PorcelainWanSettings,
    managedDevices: PorcelainManagedDevices,
    reservations: PorcelainReservations,
    switchPorts: PorcelainSwitchPorts,
    clients: PorcelainClients,
    posTerminals: PorcelainPosTerminals,
    adminUsers: PorcelainAdminUsers,
    adminRoles: PorcelainAdminRoles,
    adminPermissions: PorcelainAdminPermissions,
    adminTenants: PorcelainAdminTenants,
    adminTenantDetail: PorcelainAdminTenantDetail,
    adminApiTokens: PorcelainAdminApiTokens,
    adminCredentials: PorcelainAdminCredentials,
    adminLocations: PorcelainAdminLocations,
  },
}
